export const uploadDocuments = async ({
  userToken,
  aadharFile,
  addressFile,
}) => {
  const formData = new FormData();
  formData.append("aadhar_card", aadharFile?.file);
  formData.append("address_proof", addressFile?.file);

  console.log(
    "Uploading to:",
    `${process.env.NEXT_PUBLIC_BASE_URL}/app/v1/registration_documents_upload`
  );
  console.log("Token used:", userToken);
  console.log("Aadhar File in FormData:", aadharFile);
  console.log("Address File in FormData:", addressFile);

  try {
    const response = await fetch(
      `${process.env.NEXT_PUBLIC_BASE_URL}/app/v1/registration_documents_upload?user_token=${userToken}`,
      {
        method: "POST",
        body: formData,
      }
    );

    console.log("Server responded with status:", response.status);

    let responseData;
    const contentType = response.headers.get("Content-Type");

    if (contentType && contentType.includes("application/json")) {
      responseData = await response.json();
    } else {
      responseData = await response.text();
    }

    if (!response.ok) {
      console.error("Upload failed response:", responseData);
      return Promise.reject(responseData?.message || "Document upload failed");
    }

    console.log("Upload success response:", responseData);
    return responseData;
  } catch (error) {
    console.error("Error during document upload:", error);
    return Promise.reject(error?.message || "Document upload failed");
  }
};
